import { render, staticRenderFns } from "./price-uphold.vue?vue&type=template&id=7f5ebf1a&scoped=true&"
import script from "./price-uphold.vue?vue&type=script&lang=js&"
export * from "./price-uphold.vue?vue&type=script&lang=js&"
import style0 from "./price-uphold.vue?vue&type=style&index=0&id=7f5ebf1a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5ebf1a",
  null
  
)

export default component.exports